import Form from "./Form";
import FormStickyHeader from "../../components/FormStickyHeader";

type Props = {
  suppliers: Supplier[];
  projectManagers: { id: string; first_name: string; last_name: string }[];
};

const ProjectCreate: React.FC<Props> = ({ suppliers, projectManagers }) => {
  return (
    <div>
      <FormStickyHeader>New Project</FormStickyHeader>
      <Form suppliers={suppliers} projectManagers={projectManagers} />
    </div>
  );
};

export default ProjectCreate;
